import React, { useLayoutEffect, useState } from "react";
import classnames from "classnames";
import { useStaticQuery, graphql } from "gatsby";
import { Link, injectIntl } from "gatsby-plugin-intl";
import Logo from "../../assets/Logo";
import Section from "../section/Section";
import MenuOpenIcon from "../../assets/MenuOpenIcon";
import useNoBodyScroll from "../../hooks/useNoBodyScroll";
import LanguagePicker from "./LanguagePicker";
import cssClass from "./Navigation.module.scss";
import MobileNavigation from "./MobileNavigation";

const Navigation = ({ invert, intl }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulFindYourClinicPage {
        nodes {
          name
          slug
          node_locale
        }
      }
      allContentfulUnderstandFertilityPage {
        nodes {
          name
          slug
          node_locale
        }
      }
    }
  `);

  const {
    name: clinicsName,
    slug: clinicsSlug,
  } = data.allContentfulFindYourClinicPage.nodes.filter(
    (node) => node.node_locale === intl.locale
  )[0];

  const {
    name: articlesName,
    slug: articlesSlug,
  } = data.allContentfulUnderstandFertilityPage.nodes.filter(
    (node) => node.node_locale === intl.locale
  )[0];

  const navigationSchema = [
    {
      title: clinicsName,
      path: `/${clinicsSlug}`,
    },
    {
      title: articlesName,
      path: `/${articlesSlug}`,
    },
  ];

  const [isMobileHeader, setIsMobileHeader] = useState(true);
  const [mobileNavIsShown, setMobileNavIsShown] = useState(false);

  useNoBodyScroll(mobileNavIsShown);

  useLayoutEffect(() => {
    setIsMobileHeader(window.innerWidth < 768);
    const mediaQueryList = window.matchMedia("(min-width: 768px)");
    const listener = (e) => setIsMobileHeader(!e.matches);
    try {
      mediaQueryList.addEventListener("change", listener); // Chrome & FF
    } catch {
      mediaQueryList.addListener(listener); // Safari
    }
    return () => {
      try {
        mediaQueryList.removeEventListener("change", listener);
      } catch {
        mediaQueryList.removeListener(listener);
      }
    };
  }, []);

  const classes = classnames(cssClass.navigation, {
    [cssClass.invert]: invert,
  });

  return (
    <Section className={classes}>
      <nav>
        <ul className={cssClass.navigationList}>
          {/* TODO: keep same logo and remove from MobileNavigation */}
          <li className={cssClass.logo}>
            <Link aria-label="To homepage" to="/">
              <Logo invert={invert} />
            </Link>
          </li>

          <li className={cssClass.mobileHeader} aria-hidden={!isMobileHeader}>
            <button
              aria-label="Open navigation"
              className={cssClass.openMobileNavButton}
              onClick={() => setMobileNavIsShown(true)}
            >
              <MenuOpenIcon />
            </button>
            <MobileNavigation
              isOpen={mobileNavIsShown}
              closeFunction={() => setMobileNavIsShown(false)}
            />
          </li>

          <li className={cssClass.desktopHeader} aria-hidden={isMobileHeader}>
            <ul>
              {navigationSchema.map((navigationItem) => (
                <li key={navigationItem.title} className={cssClass.listItem}>
                  <Link
                    partiallyActive
                    activeClassName={classnames(cssClass.activePath, {
                      [cssClass.activePathInverted]: invert,
                    })}
                    to={navigationItem.path}
                  >
                    {navigationItem.title}
                  </Link>
                </li>
              ))}
              <li className={cssClass.languagePickerWrapper}>
                <LanguagePicker invert={invert} />
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </Section>
  );
};

export default injectIntl(Navigation);
